module.exports = __webpack_public_path__ + "img/0.f2ca5f72.svg";